    import { createAction, props } from '@ngrx/store';

export const addToLobbySuccess = createAction(
    '[Appointment Status Grid API] Add to Lobby Success',
    props<{lobbyEntryId: number}>()
);

export const addToLobbyFailure = createAction(
    '[Appointment Status Grid] Add to Lobby Fail',
    props<{error: string}>()
);

export const updateAppointmentStatusSuccess = createAction(
    '[Appointment Status Grid API] Update Appointment Status Success'
);

export const updateAppointmentStatusFailure = createAction(
    '[Appointment Status Grid] Update Appointment Status Fail',
    props<{error: string}>()
);
